export const ROW_HEIGHT = 35;

export const TIMEBAND_LEVEL_NAME = "Timeband";
export const OUTER_LEVEL_NAME = "Outer";
export const SECTOR_LEVEL_NAME = "Sector";
export const POSTCODE_LEVEL_NAME = "Postcode";

export const COLUMNS = [
  {
    key: "name",
    name: TIMEBAND_LEVEL_NAME,
    width: 140,
  },
  {
    key: "cadTotals",
    name: "Cad Totals",
    width: 150,
  },
  {
    key: "cumulativeTotals",
    name: "Cumulative Totals",
    width: 160,
  },
  {
    key: "smallsTotals",
    name: "Smalls Totals",
    width: 150,
  },
  {
    key: "smallsCumulative",
    name: "Smalls Cumulative",
    width: 160,
  },
  {
    key: "bulkTotals",
    name: "Bulk Totals",
    width: 150,
  },
  {
    key: "bulkCumulative",
    name: "Bulk Cumulative",
    width: 160,
  },
  {
    key: "defaultTotals",
    name: "Default Totals",
    width: 150,
  },
  {
    key: "defaultCumulative",
    name: "Default Cumulative",
    width: 160,
  },
  {
    key: "stopsNullPostcode",
    name: "Stops Null postcode",
    width: 160,
  },
  {
    key: "invalidPostcode",
    name: "Invalid Postcode",
    width: 160,
  },
].map((column, i, columns) => ({
  ...column,
  left: columns.slice(0, i).reduce((acc, { width }) => (acc += width), 0),
}));

export const HEADER_ROW_TEMPLATE = {
  name: TIMEBAND_LEVEL_NAME,
  level: TIMEBAND_LEVEL_NAME,
  cadTotals: "Cad Totals",
  cumulativeTotals: "Cumulative Totals",
  smallsTotals: "Smalls Totals",
  smallsCumulative: "Smalls Cumulative",
  bulkTotals: "Bulk Totals",
  bulkCumulative: "Bulk Cumulative",
  defaultTotals: "Default Totals",
  defaultCumulative: "Default Cumulative",
  stopsNullPostcode: "Stops Null postcode",
  invalidPostcode: "Invalid Postcode",
  isHeaderRow: true,
};

export const ROW_TEMPLATE = {
  level: TIMEBAND_LEVEL_NAME,
  cadTotals: 0,
  cumulativeTotals: 0,
  smallsTotals: 0,
  smallsCumulative: 0,
  bulkTotals: 0,
  bulkCumulative: 0,
  defaultTotals: 0,
  defaultCumulative: 0,
  stopsNullPostcode: 0,
  invalidPostcode: 0,
};
